export interface IFacilityInventory {
    id?: number;
    storeId: number;
    typeId: number;
    supplierId?: number;
    inventoryValues?: IFacilityInventoryValue[];
}

export interface IFacilityInventoryValue {
    id?: number;
    inventoryId?: number;
    columnId: number;
    value?: string;
}

export interface IFacilityInventoryColumn {
    id: number;
    name: string;
    sortOrder: number;
    dataType: number;
    format?: string;
    lookupTableId?: number;
    foreignKey?: IFacilityForeignKey;
    templates?: any[];
    systemTable?: any;
}

export interface IFacilityForeignKey {
    type: string;
    id: string;
    name: string,
}

export enum FacilityInventoryDataType {
    Text = 1,
    Number = 2,
    Boolean = 3,
    Date = 4,
    DateTime = 5,
    Memo = 6
}

export interface IFacilityInventoryStructure {
    typeId: number;
	typeName: string;
	industryTag?: string;
    columns: IFacilityInventoryColumn[];
    items?: IFacilityInventoryStructureItem[];
}

export interface IFacilityInventoryStructureItem {
    id: number;
    supplierId?: number;
    inventoryValues: IFacilityInventoryValue[];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_entities/facility-inventory.ts